import { render, staticRenderFns } from "./FooterBtn.vue?vue&type=template&id=2525290c&scoped=true&"
import script from "./FooterBtn.vue?vue&type=script&lang=js&"
export * from "./FooterBtn.vue?vue&type=script&lang=js&"
import style0 from "./FooterBtn.vue?vue&type=style&index=0&id=2525290c&scoped=true&lang=css&"
import style1 from "./FooterBtn.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2525290c",
  null
  
)

export default component.exports